module.exports = __webpack_public_path__ + "media/img0.855285cb.mp4";